import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./styles/app.css";
import "./styles/chat-page.css";
import "./styles/variables.css";
import "./styles/theme.css";
import "./styles/layout.css";
import "./styles/components.css";
import "./styles/task-thread.css";
import "./styles/bootstrap-theme-override.css";
import { AppProvider } from "./APIHelpers/AppContext";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppProvider>
    <App />
  </AppProvider>,
);
